export enum OAuth2ZohoPrompt {
    Consent = 'consent',
}
